import { onBeforeUnmount, onMounted } from 'vue';
import { captureException } from '@sentry/vue';
import { useMessageStore } from '../store/messages';

export function useGlobalErrorHook() {
  const messageStore = useMessageStore();

  const onError = (event: ErrorEvent) => {
    // "ResizeObserver loop completed with undelivered notifications" (và "... limit exceeded"): trình duyệt báo thông báo đổi
    // cỡ dời sang khung hình sau — không phải lỗi ứng dụng, không kèm Error. Báo lên thành Application error là mỗi lần
    // tooltip / khung co giãn một hộp "No error details available" (nhúng trong RIS dính hàng loạt).
    if (!event.error && /ResizeObserver loop/.test(event.message ?? '')) {
      console.warn(event.message);
      return;
    }
    console.error(event);
    const error = event.error ?? event.message ?? 'Unknown global error';

    captureException(error);

    const errorOptions =
      error instanceof Error ? { error } : { details: String(error) };
    messageStore.addError(
      'Application error (click for details)',
      errorOptions
    );
  };

  onMounted(() => {
    window.addEventListener('error', onError);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('error', onError);
  });
}
